import React, { useRef } from 'react';
import { Box } from '@components/Box';
import { useOnScreenTelemetry } from '@hooks/useOnScreenTelemetry';
import { ImageWrapper, TextContainer, TextDiv, WebsiteImage, WebsiteImageMobile } from './CelebratingCoupleSection.styles';
import { useTranslation } from 'react-i18next';

const SECTION_ID = 'FindAnEvent_Celebrating_Couple_Section';

export const CelebratingCoupleSection: React.FC = () => {
  const celebratingCoupleSectionRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation('findAnEvent');
  const { celebratingCouple } = t('findAnEvent');

  useOnScreenTelemetry(celebratingCoupleSectionRef, SECTION_ID);

  return (
    <Box id={SECTION_ID} ref={celebratingCoupleSectionRef}>
      <ImageWrapper>
        <TextContainer>
          <TextDiv tagName="div" variant="hed72Hero" color="yellow5">
            {celebratingCouple?.title}
          </TextDiv>
        </TextContainer>
        <WebsiteImage
          width="100%"
          src="find-an-event/celebrating_section_desktop.jpg"
          alt="find-an-event-celebration"
          optimization="aggressive"
        />
        <WebsiteImageMobile
          width="100%"
          src="find-an-event/celebrating_section_mobile.jpg"
          alt="find-an-event-celebration-mobile"
          optimization="aggressive"
        />
      </ImageWrapper>
    </Box>
  );
};
